
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|4331|5175|7729)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
